import {Icon} from "@blueprintjs/core";
import styled from "@emotion/styled";
import React from "react";

type DropdownClearButtonProps = {
  onClear: () => void;
  hasValue: boolean;
  size?: number;
};

const DropdownClearButton = ({onClear, hasValue, size = 16}: DropdownClearButtonProps) => {
  return (
    <StyledContainer hasValue={hasValue}>
      <Icon className="icon dropdown" icon="chevron-down" size={size} />
      {<Icon className="icon clear" icon="cross" size={size} onClick={onClear} />}
    </StyledContainer>
  );
};

export default DropdownClearButton;

const StyledContainer = styled.div<{hasValue: boolean}>`
  .icon {
    padding: 2px;
    border-radius: 4px;
  }

  .icon.clear {
    display: none;
    background-color: #f3f4f6;
  }

  ${(props) =>
    props.hasValue &&
    `:hover {
      .icon.dropdown {
        display: none;
      }
      .icon.clear {
        display: block;
      }
    }
  `}
`;
